/* eslint-disable max-lines */
export const CLICK_ACTIONS = {
    CLICK_PROCEED_TO_PAY: "click-proceed-to-pay",
    CLICK_ADD_MORE_ITEMS: "click-add-more-items",
    CLICK_REMOVE_ALL_OOS_ITEMS: "click-remove-all-oos-items",
    CLICK_REMOVE_SINGLE_OOS_ITEM: "click-remove-single-oos-item",
    CLICK_LOGIN: "click-login",
    CLICK_ADD_ADDRESS: "click-add-address",
    CLICK_CHANGE_ADDRESS: "click-change-address",
    CLICK_RELOAD_ADDRESSES: "click-reload-addresses",
    CLICK_ADD_OR_SELECT_ADDRESS: "click-add-or-select-address",
    CLICK_CLEAR_CART: "click-clear-cart",
    CLICK_VIEW_DETAILED_BILL: "click-detail-bill",
    CLICK_ITEM_ADD: "click-item-add",
    CLICK_ITEM_INCREMENT: "click-item-increment",
    CLICK_ITEM_DECREMENT: "click-item-decrement",
    CLICK_CUSTOMISATION_UPDATE_ITEM: "click-customization-update-item",
    CLICK_ADDRESS_SELECT: "click-address-select",
    CLICK_CART_SUPER_NUDGE: "click-cart-super-nudge",
    CLICK_REMOVE_SUPER: "click-remove-super",
    CLICK_CART_SUPER_NUDGE_ONE_TAP_ADD: "click-cart-super-nudge-one-tap-add",
    CLICK_INFO_ICON: "click-infoicon",
    CLICK_CART_SUPER_CHANGE_PLAN: "cart-super-change-plan",
    CLICK_CANCELLATION_POPUP_UNDERSTAND: "click-cancellation-popup-understand",
    CLICK_CANCELLATION_POPUP_X: "click-cancellation-popup-x",
    CLICK_CANCELLATION_POPUP_READ_POLICY: "click-cancellation-popup-read-policy",
    CLICK_TIP_AMOUNT_PREDEF: "click-tip-amount-predefined",
    CLICK_TIP_AMOUNT_CUSTOM: "click-tip-amount-custom",
    CLICK_OPT_IN: "click-opt-in",
    CLICK_BILL_DETAILS_ADD_TIP: "click-bill-details-add-tip",
    CLICK_RESTAURANT: "click-restaurant",
    CLICK_SAVINGS_POPUP: "coupon-savings-popup",
    CLICK_MAX_SAVINGS_POPUP: "max-savings-popup",
    CLICK_APPLY_COUPON: "click-avail-offers-coupons",
    CLICK_CUTLERY_TRUE: "cutlery-clicked-true",
    CLICK_CUTLERY_FALSE: "cutlery-clicked-false",
    CLICK_CANCELLATION_INLINE_OVERVIEW: "click-cancellation-inline-overview",
    CLICK_CANCELLATION_DETAILED_READ_POLICY: "click-cancellation-detailed-read-policy",
    CLICK_AVAIL_OFFERS_COUPONS: "click-avail-offers-coupons",
    CLICK_SPECIAL_INSTRUCTIONS: "click-special-instruction",
    CLICK_SAVE_SPECIAL_INSTRUCTIONS: "click-save-special-instruction",
    CLICK_SPECIAL_INSTRUCTION_REQUEST: "click_special_instruction_request",
    CLICK_SPECIAL_INSTRUCTION_REQUEST_EDIT: "cooking_request_edit",
    CLICK_DELIVERY_INSTRUCTION: "add-delivery-instructions",
    CLICK_VIEW_SIMILAR_CTA_GOTOHOME: "click-view-similar-cta-gotohome",
    CLICK_VIEW_SIMILAR_CTA_GOTOCOLLECTIONS: "click-view-similar-cta-gotocollections",
    CLICK_EDIT_DETAILS: "click-edit-details",
    CLICK_ADD_DETAILS: "click-add-details",
    CLICK_DELIVERY_INSTRUCTION_CROUTON: "click-delivery-instruction-crouton",
    CLICK_OFO_CHECKOUT_DETAILS: "click-ofo-at-checkout-details",
    CLICK_APPLY_COUPON_BUTTON: "apply-coupon-click",
    CLICK_VIEW_MORE_COUPONS: "view-more-coupons-click",
    CLICK_SUPER_REMOVE_PLAN_HALF_CARD_BACK_BUTTON: "click-super_remove-plan-half-card-back-button",
    CLICK_SUPER_REMOVE_PLAN_HALF_CARD_REMOVE_BUTTON: "click-super-remove-plan-half-card-remove-button",
    CLICK_ADDRESS_WIDGET_TOP: "click-change-address-top-one-line",
    CLICK_CART_HEADER_DROPDOWN: "address-click-one-line-header",
    CLICK_TOOLTIP_OFFERCASH: "click-tooltip-offercash",
    CLICK_CLOSE_DELIGHT_POPUP: "click-close-delight-popup",
    CLICK_SELECT_DELIVERY_SLOT_BUTTON: "click-select-delivery-slot-button",
    CLICK_DROPPT_DELIVERY_SLOT: "click-droppt-delivery-slot",
    CLICK_COUPON_OFFERS: "click-coupon-offers",
    CLICK_MORE_DETAILS: "click-more-details",
    CLICK_APPLY_COUPON_TEXT_FIELD: "click-apply-coupon",
    CLICK_ADD_DRINK: "click-add-drink",
    CLICK_ADD_DESSERT: "click-add-dessert",
    CLICK_SUPER_VIEW_DETAILS_FOOTER: "click-view-policy",
    CLICK_SUPER_VIEW_ALL_BENEFITS_CTA: "click-view-all-benefits",
    CLICK_OCASSIONS_ADD_MORE_ITEMS_BUTTON: "click-ocassions-add-more-items-button",
    CLICK_OCASSIONS_VIEW_MORE_OUTLETS_BUTTON: "click-ocassions-view-more-outlets-button",
    CLICK_OCASSIONS_PROCEED_TO_PAY_BUTTON: "click-ocassions-proceed-to-pay-button",
    CLICK_ADD_ITEM_SAVE_MORE: "click-add-item-save-more",
    CLICK_ADD_ITEM_CAROUSEL: "click-add-item-carousel",
    CLICK_ITEM_DETAILS_CAROUSEL: "click-item-details-carousel",
    CLICK_CROSS_SELL_CHANGE_TAB: "click-change-tab-carousel",
    CLICK_DISMISS_MAGIC_ITEMS_UNLOCK_POPUP: "click-dismiss-magic-items-unlock-popup",
    CLICK_EXPLORE_MENU_MAGIC_ITEMS: "click-explore-menu-magic-items",
    CLICK_CROUTON_OFFER: "click-view-payment-offers",

    CLICK_REMOVE_OFFER_BUNDLE_CONFIRM: "remove-offer-bundle-cart-confirmation_click",
    CLICK_REMOVE_OFFER_BUNDLE_M2C_CONFIRM: "remove-offer-bundle-m2c-confirmation-click",
    CLICK_NUDGE_WIDGET: "offer_bundle_checkout_widget_click",
    CLICK_INLINE_WIDGET: "offer_bundle_incart_widget_click",

    CLICK_REMOVE_APPLIED_COUPON: "click-remove-applied-coupon",

    CLICK_ADD_SWIGGY_ONE: "click-add-swiggy-one",
    CLICK_CONTINUE_TO_CART: "click-continue-to-cart",
    CLICK_MAKE_IT_FREE: "click-make-it-free",

    CLICK_MENU_BACK: "click-menu-back",
    CLICK_MENU_BACK_DYNAMIC: "click-menu-back-dynamic",
    // Delivery Speed Click Events
    CLICK_FTUE_NORUSH_HALF_CARD: "ftue_half_card_norush_click",
    CLICK_FTUE_STANDARD_HALF_CARD: "ftue_half_card_standard_click",
    CLICK_CART_NORUSH: "cart_norush_click",
    CLICK_CART_STANDARD: "cart_standard_click",
    CLICK_CART_NORUSH_NUDGE: "cart_norush_nudge_click",
    CLICK_CART_STANDARD_POPUP: "click_delivery_switch_standard",
    CLICK_CART_NORUSH_POPUP: "click_delivery_keep_smartsaver",
    CLICK_EXPRESS_DELIVERY: "click-express-delivery",
    CLICK_EXPRESS_BUY_BLCK_NUDGE: "click-express-buy-blck-nudge",
    CLICK_CART_DELIVERY_TYPE: "cart_delivery_type",

    // delivery eco-saver toast
    CLICK_ECO_SAVER_TOAST_MESSAGE: "click-toast-message",

    // irctc click events
    USER_DETAILS_SEAT_IRCTC: "user_details_seat_irctc",
    USER_DETAILS_CONTACT_IRCTC: "user_details_contact_irctc",
    IRCTC_PNR_ENTER_VERIFY: "enter_verify",
    USER_DETAILS_BANNER_IRCTC: "user-details-banner-irctc",
    CLICK_ENTER_PNR: "click-enter-pnr",
    UPDATE_DETAILS_IRCTC: "update-details-irctc",

    // on-premise fulfilment (Cinepolis)
    SELECT_ORDER_TYPE: "select-order-type",
    EDIT_ORDER_TYPE: "edit-order-type",
    EDIT_MOBILE_NUMBER: "edit-mobile-number",
    ORDER_TYPE_HALFCARD: "order-type-halfcard",

    // CBCC Remind me nudge events
    CLICK_REMIND_ME_NUDGE: "click-remind-me-nudge",

    // group cart
    CLICK_GROUP_CART_ITEM: "click-grp-cart-item",
    CLICK_GROUP_CHECKOUT_CTA: "click-grp-cart-checkout-cta",

    // incognito-cart
    CLICK_TOGGLE_ON: "click-toggle-on",
    CLICK_TOGGLE_OFF: "click-toggle-off",
    CLICK_CONTEXTUAL_BANNER_DISMISS: "click-contextual-banner-dismiss",
    // menu items callout
    CLICK_ITEMS_BANNER: "items-topical-banner",
    CLICK_ITEMS_BANNER_HALF_CARD_CTA: "menu-items-callout-hc",

    // Gratification Popup
    CLICK_ONE_GRATIFICATION_POPUP: "click-one-gratification-popup",

    // One Membership Nudge
    CLICK_ONE_CARTUPSELL_HALFCARD_CHEVRON: "click-onecartupsell-halfcard-chevron",
    CLICK_ADD_CTA_BUTTON_ONE_CARTUPSELL: "click-add-cta-button-onecartupsell",
    CLICK_REMOVE_PLAN_ONE_CARTUPSELL: "click-remove-swiggy-onecartupsell",
    CLICK_ONE_CARTUPSELL_PLAN_REMOVAL_HALFCARD: "click-one-cartupsell-plan-removal-halfcard",
    CLICK_CHANGE_PLAN_CTA: "cart-upsell-change-plan-click",

    // delivery tab
    CLICK_DELIVERY_TAB: "click-toggle-select",

    // Remove coupon
    CLICK_REMOVE_COUPON: "click-remove-coupon",

    // Half card invalid coupon
    CLICK_HALF_CARD_INVALID_COUPON: "click-half-card-invalid-coupon",
    // Savings corner habitforming
    CLICK_SAVINGS_CORNER_HABIT_VIEW_REWARD: "click-savings-corner-habit-view-reward",

    // One time promise
    CLICK_ONE_BLACK_HALFCARD_CLOSE: "click-one-blck-halfcard-close",
    CLICK_ONE_BLACK_HALFCARD_CTA: "click-one-blck-halfcard-cta",
    CLICK_OTP_CROUTON_CLOSE: "click-otp-crouton-close",
    CLICK_DELIVERY_FEE_LINE_ITEM: "click-delivery-fee-line-item",

    //cutlery opt-in widget
    CLICK_CUTLERY_OPT_IN_WIDGET: "click-send-cutlery",

    //cart address nudge
    CLICK_ADDRESS_DISTANCE_NUDGE_CLOSE_BUTTON: "click-address-distance-nudge-close-button",
    CLICK_ADDRESS_CHANGE_BACK: "click-address-change-back",

    // cart message personalised
    CLICK_ADD_CAKE_MESSAGE_PILL: "click-cake-special-instruction",
    CLICK_HALF_CARD_CAKE_BUTTON: "click-half-card-cake-button",
    CLICK_ADD_MESSAGE_HALF_CARD: "click-bottom-half-card",
    // more offers strip
    CLICK_MORE_OFFERS_STRIP: "click-more-offers-strip",

    //special instructions half card
    CLICK_HALF_CART_SUBMIT_REQUEST: "click-half-cart-submit-request",
    CLICK_HALF_CART_REMOVE_REQUEST: "click-half-cart-remove-request",
    CLICK_HALF_CART_UPDATE_REQUEST: "click-half-cart-update-request",
    CLICK_HALF_CART_CLOSE: "click-half-cart-close",

    // Gifting Flow Click Events
    CLICK_APPLY_SELECTED_COUPON_PAGE: "click-apply-selected-coupon-page",
    CLICK_COUPON_SELECT_CHECKBOX: "click-coupon-select-checkbox",
    CLICK_COUPON_DESELECT_CHECKBOX: "click-coupon-deselect-checkbox",
    CLICK_BACK_COUPON_PAGE: "click-back-coupon-page",
    CLICK_APPLY_SEARCH_BAR: "click-apply-search-bar",
    CLICK_POP_UP: "click-pop-up",
    CLICK_CROSS_POP_UP: "click-cross-pop-up",
    CLICK_BROWSE_RESTAURANTS: "click-browse-restaurants",

    // TURBO STRIP
    CLICK_TURBO_STRIP: "click-payment-strip",
    // Tooltip
    CLICK_TOOLTIP_CLOSE: "click-tooltip",
    CLICK_FREEBIE_CLAIM_BUTTON: "click-freebie-claim-button",
    CLICK_STEAL_DEAL_CLAIM_BUTTON: "click-stealdeal-add-button",

    // Toing Popup
    CLICK_DISMISS_TOING_RE_ENFORCEMENT: "click-dismiss-toing-re-enforcement",
    CLICK_YAY_TOING_RE_ENFORCEMENT: "click-yay-toing-re-enforcement",

    // Bill Details Banner
    CLICK_BILL_DETAILS_BANNER: "click-bill-details-banner",
    CLICK_BILL_DETAILS_BANNER_HALF_CARD: "click-bill-details-banner-halfcard",
    // Subscription Renewal Nudge
    CLICK_BLACK_PLAN_ADD_BUTTON: "click-add-cta-button-cartupsell-black",
    CLICK_BLACK_PLAN_REMOVE_BUTTON: "click-cartupsell-removal-nudge-black",
    CLICK_ONE_PLAN_ADD_BUTTON: "click-add-cta-button-cartupsell-one",
    CLICK_ONE_PLAN_REMOVE_BUTTON: "click-cartupsell-removal-nudge-one",
    CLICK_COMPARE_PLAN_ON_SUBSCRIPTION_RENEWAL_ONE_PLAN: "click-header-cartupsell-one",
    CLICK_COMPARE_PLAN_ON_SUBSCRIPTION_RENEWAL_BLACK_PLAN: "click-header-cartupsell-black",
    CLICK_SUBSCRIPTION_RENEWAL_PLAN_REMOVAL_HALFCARD: "click-subscription-renewal-plan-removal-halfcard",

    // Deal Rush Crouton
    CLICK_DEAL_RUSH_CROUTON_CLOSE_ICON: "click-offer-timer-crouton",

    // IPL Swiggy Sixes floaty crouton
    CLICK_SS_FLOATY_CLOSE: "click-ss-floaty-close",

    // Toing Lpg Banner
    CLICK_TOP_CART_BANNER_D2C: "click-top-cart-banner-d2c",
    CLICK_NO_ADDRESS_D2C: "click-no-address-d2c",
    CLICK_TUTORIAL_D2C: "click-tutorial-d2c",
    CLICK_RESULT_REJECT_D2C: "click-result-reject-d2c",
    CLICK_CLOSE_D2C_HALF_CARD: "click-close-d2c-half-card",
    CLICK_FREE_CASH_WARNING_D2C: "click-free-cash-warning-d2c",

    // TOING Delivery Modes
    CLICK_FTUE_CROUTON: "delivery-mode-ftue",

    // No Weekend Fee Popup
    CLICK_NO_WEEKEND_FEE_POPUP: "click-no-weekend-fee-pop-up",
};

export const IMPRESSION_ACTIONS = {
    IMPRESSION_OFFER_CASH_REWARD_LINE_ITEM: "impression-offer-cash-reward-line-item",
    IMPRESSION_ADD_OR_SELECT_ADDRESS: "impression-add-or-select-address",
    IMPRESSION_ADDRESS_LIST_ERROR: "impression-address-list-error",
    IMPRESSION_CHECKOUT_CROSS_SELLING: "impression-checkout-cross-selling",
    IMPRESSION_AUTO_APPLIED_COUPON_POPUP: "impression-auto-applied-coupon-pop-up",
    IMPRESSION_CHECKOUT_BILL_SUMMARY: "impression-checkout-bill-summary",
    IMPRESSION_NORMAL_CUSTOMIZATION: "impression-normal-customization",
    IMPRESSION_PROGRESSIVE_CUSTOMIZATION: "impression-progressive-customization",
    IMPRESSION_CROSS_SELLING_ITEM: "impression-cross-selling-item",
    IMPRESSION_CART_SUPER_NUDGE: "impression-cart-super-nudge",
    IMPRESSION_LIFETIME_SAVINGS_CALLOUT: "impression-lifetime-savings-callout",
    IMPRESSION_CART_SUPER_NUDGE_ONE_TAP: "impression-cart-super-nudge-one-tap",
    IMPRESSION_CART_SUPER_OFFER_BADGE: "impression-cart-super-offer-badge",
    IMPRESSION_CANCELLATION_POPUP: "impression-cancellation-popup",
    IMPRESSION_CANCELLATION_BLACK_PROMPT: "impression-cancellation-black-prompt",
    IMPRESSION_TIPPING_WIDGET: "impression-tipping-widget",
    IMPRESSION_CART_SAVINGS: "impression-cart-savings",
    IMPRESSION_CUTLERY_SHOWN: "cutlery-shown",
    IMPRESSION_CUTLERY_NOT_SHOWN: "cutlery-not-shown",
    IMPRESSION_CANCELLATITON_INLINE_OVERVIEW: "impression-cancellation-inline-overview",
    IMPRESSION_CANCELLATION_INLINE_DETAIL: "impression-cancellation-inline-detail",
    IMPRESSSION_SPECIAL_INSTRUCTIONS: "impression-special-instruction",
    IMPRESSSION_SPECIAL_INSTRUCTION_REQUEST: "impression_special_instruction_request",
    IMPRESSION_CHANGE_PLAN: "impression-change-plan",
    IMPRESSION_SUPER_VIEW_ALL_BENEFITS_CTA: "impression-view-all-benefits",
    IMPRESSION_OFFER_NUDGE: "offer-nudge",
    IMPRESSION_CART_DELIVERY_INSTRUCTION: "add-delivery-instructions",
    IMPRESSION_CART_DELIVERY_INSTRUCTION_SUBTEXT: "subtext-below-instruction-boxes",
    IMPRESSION_DIRECTIONS_TO_REACH_CARD: "impression-add-delivery-instructions-directions-to-reach",
    IMPRESSION_VOICE_DIRECTIONS_TOOLTIP: "impression-voice-directions-ftux-tool-tip",
    IMPRESSION_NO_ADDRESS_SELECTED: "no-address-selected",
    IMPRESSION_TIMER_ON_CART: "impression_timer",
    IMPRESSION_VIEW_SIMILAR_CTA_GOTOHOME: "impression-view-similar-cta-gotohome",
    IMPRESSION_VIEW_SIMILAR_CTA_GOTOCOLLECTIONS: "impression-view-similar-cta-gotocollections",
    IMPRESSION_EDIT_DETAILS: "impression-edit-details",
    IMPRESSION_ADD_DETAILS: "impression-add-details",
    IMPRESSION_DELIVERY_INSTRUCTION_CROUTON: "impression-delivery-instruction-crouton",
    IMPRESSION_OFO_CHECKOUT_DETAILS: "impression-ofo-at-checkout-details",
    IMPRESSION_SELF_DELIVERY_INSTRUCTIONS: "impression-self-delivery-instructions",
    IMPRESSION_SUPER_REMOVE_PLAN_CONFIRMATION_HALF_CARD: "impression-super-remove-plan-confirmation-half-card",
    IMPRESSION_SUPER_REMOVE_PLAN_HALF_CARD_BACK_BUTTON: "impression-super-remove-plan-half-card-back-button",
    IMPRESSION_SUPER_REMOVE_PLAN_HALF_CARD_REMOVE_BUTTON: "impression-super-remove-plan-half-card-remove-button",
    IMPRESSION_ADDRESS_WIDGET_TOP: "address-imp-one-line",
    IMPRESSION_CROUTON_OFFER: "impression-view-payment-offers",
    IMPRESSION_GIFTING_APPLIED_COUPON: "impression-applied-offer",
    IMPRESSION_FREEBIE_WIDGET: "impression-freebie",
    IMPRESSION_STEAL_DEAL_WIDGET: "impression-stealdeal",
    IMPRESSION_ORDER_TYPE_HALFCARD: "order-type-halfcard",

    // Address PSLA Banner Impression Events
    IMPRESSION_ADDRESS_PSLA_BANNER: "psla-banner",

    // Menu Items Callout Impression Events
    IMPRESSION_ITEMS_BANNER: "items-topical-banner",
    IMPRESSION_ITEMS_BANNER_HALF_CARD: "menu-items-callout-hc",

    IMPRESSION_CART_HEADER: "address-imp-one-line-header",
    IMPRESSION_ITEMLIST_HEADER: "impression-itemlist_header",
    IMPRESSION_ITEM_LIST_SECTION_HEADER: "impression-item-list-section_header",
    IMPRESSION_CART_SAVINGS_ONE_LINE: "impression-cart-savings-one-line",
    IMPRESSION_SELECT_DELIVERY_SLOT_BUTTON: "impression-select-delivery-slot-button",
    IMPRESSION_DROPPT_DELIVERY_SLOT: "impression-droppt-delivery-slot",
    IMPRESSION_PROCEED_TO_PAY: "impression-proceed-to-pay-button",
    IMPRESSION_OFFERCASH_DELIGHT_POPUP: "impression-offercash-delight-popup",
    IMPRESSION_OFFERCASH_COUPON_SUCCESS_POPUP: "impression-offercash-coupon-success-popup",
    IMPRESSION_PROCEED_TO_PAY_TURBO: "impression-proceed-to-pay",
    IMPRESSION_COUPON_OFFERS: "impression-coupon-offers",
    IMPRESSION_SS_FLOATY: "impression-ss-floaty",
    IMPRESSION_REWARD_OFFERS: "impression-reward-offers",
    IMPRESSION_OFFERS: "impression-offers",
    IMPRESSION_CART_PAGE_UPDATED: "impression-cart-page-updated", // for dev debug purposes
    IMPRESSION_ADD_DESSERT: "impression-add-dessert",
    IMPRESSION_ADD_DRINK: "impression-add-drink",
    IMPRESSION_DIRECT_COUPON_WIDGET: "apply-coupon-imp",
    IMPRESSION_SUPER_VIEW_DETAILS_FOOTER: "impression-view-policy",
    IMPRESSION_IMAGE_CARD: "impression-image-card",
    IMPRESSION_OCASSIONS_PROCEED_TO_PAY_BUTTON: "impression-ocassions-proceed-to-pay-button",
    IMPRESSION_ADD_ITEM_SAVE_MORE: "impression-add-item-save-more",
    IMPRESSION_PAYMENT_BANNER: "impression-payment-banner",

    IMPRESSION_REMOVE_OFFER_BUNDLE_CONFIRM: "remove-offer-bundle-cart-confirmation",
    IMPRESSION_REMOVE_OFFER_BUNDLE_M2C_CONFIRM: "remove-offer-bundle-m2c-confirmation",
    IMPRESSION_ACTIVE_STATE: "offer-bundle-save-widget",
    IMPRESSION_NUDGE_WIDGET: "offer_bundle_checkout_widget",
    IMPRESSION_INLINE_WIDGET: "offer_bundle_checkout_widget_offer_bundle_incart_widget",
    IMPRESSION_TOOLTIP_INFO_TEXT: "offer_bundle_info_impression",

    IMPRESSION_OTHER_COUPONS_UNAVL_MSG: "impression-other-coupons-unavl-msg",
    IMPRESSION_COUPON_GROUPING: "imp-coupon-grouping",
    IMPRESSION_BILL_TOTAL_GROUPING: "imp-bill-total-grouping",
    IMPRESSION_TIPPING_GROUPING: "imp-tipping-grouping",
    IMPRESSION_DELIVERY_INSTRUCTION_GROUPING: "imp-delivery-instruction-grouping",
    IMPRESSION_ADD_ITEM_CAROUSEL: "impression-add-item-carousel",
    IMPRESSION_CAROUSEL_ITEM: "impression-carousel-item",
    IMPRESSION_ITEM_IMAGE: "impression-item-image",

    IMPRESSION_COUPON_GROUPING_ACTUAL: "imp-coupon-grouping_actual",
    IMPRESSION_BILL_TOTAL_GROUPING_ACTUAL: "imp-bill-total-grouping_actual",
    IMPRESSION_TIPPING_GROUPING_ACTUAL: "imp-tipping-grouping_actual",
    IMPRESSION_DELIVERY_INSTRUCTION_GROUPING_ACTUAL: "imp-delivery-instruction-grouping_actual",

    IMPRESSION_SWIGGY_PLAN_BULLS_EYE_HALFCARD: "impression-one-cart-half-card",
    IMPRESSION_SWIGGY_PLAN_BULLS_EYE_HALFCARD_GRATIFICATION: "impression-one-cart-half-card-gratification",
    IMPRESSION_ADD_SWIGGY_ONE: "impression-add-swiggy-one",
    IMPRESSION_CONTINUE_TO_CART: "impression-continue-to-cart",

    // Delivery Speed Impression Events
    IMPRESSION_FTUE_DELIVERY_TYPE_HALF_CARD: "ftue_delivery_type_half_card_impression",
    IMPRESSION_CART_DELIVERY_TYPE: "cart_delivery_type_impression",
    IMPRESSION_OPT_IN_WIDGET: "cart_rmc_impression",
    IMPRESSION_CART_NORUSH_NUDGE: "cart_norush_nudge_impression",
    IMPRESSION_CART_DELIVERY_TYPE_NUDGE: "impression_delivery_type_mov_nudge",
    IMPRESSION_CART_DELIVERY_TYPE_POPUP: "impression_delivery_switch_popup",
    IMPRESSION_EXPRESS_BUY_BLCK_NUDGE: "impression-express-buy-blck-nudge",

    //Turbo Strip
    IMPRESSION_TURBO_STRIP: "impression-payment-strip",

    // Tooltip
    IMPRESSION_TOOLTIP: "impression-tooltip",

    //irctc address change impression
    USER_DETAILS_BANNER_IRCTC: "user-details-banner-irctc",
    IMPRESSION_DELIVERY_BANNER: "delivery-banner-irctc",
    IMPRESSION_ENTER_PNR: "impression-enter-pnr",
    IMPRESSION_FOT_CART_ERROR: "impression-fot-cart-error",

    // One Widget Impression and click Events
    IMPRESSION_SWIGGY_ONE_SAVINGS: "impression-swiggy-one-savings-nudge",
    IMPRESSION_SWIGGY_ONE_EO_COMPLETION_NUDGE: "impression-swiggy-one-eo-completion-nudge",
    CLICK_SWIGGY_ONE_EO_COMPLETION_NUDGE: "click-swiggy-one-eo-completion-nudge",

    IMPRESSION_DELIVERY_FEE_LINE_ITEM: "impression-delivery-fee-line-item",
    IMPRESSION_TAXES_AND_CHARGES_POPUP: "taxes-and-charges-pop-up",
    IMPRESSION_DELIVERY_FEE_UN_COLLAPSED_LINE_ITEM: "impression-delivery-fee-un-collapsed-line-item",
    // CBCC Remind me nudge events
    IMPRESSION_REMIND_ME_NUDGE: "impression-remind-me-nudge",
    IMPRESSION_THANKYOU_FOR_SHOWING_INTEREST: "impression-thank-you-for-showing-interest",
    IMPRESSION_RESPONSE_RECEIVED: "impression-response-received",

    // flipkart app installed
    IMPRESSION_FLIPKART_INSTALLED: "flipkart-app-installed-identifier",

    // collapsable bill details
    IMPRESSION_BILL_VIEW_CHEVRON: "impression-bill-view-chevron",
    CLICK_BILL_VIEW_CHEVRON: "click-bill-view-chevron",
    IMPRESSION_BILL_WIDGET_UPSELL_DATA: "impression-bill-widget-upsell-data",

    // group cart
    IMPRESSION_GROUP_CART: "impression-grp-cart",
    IMPRESSION_GROUP_CART_ITEM: "impression-grp-cart-item",
    IMPRESSION_GROUP_CHECKOUT_CTA: "impression-grp-cart-checkout-cta",

    // cart toast
    IMPRESSION_TOAST_MESSAGE: "impression-toast-message",

    // incognito-cart
    IMPRESSION_TOGGLE_WIDGET: "impression-toggle-widget",
    IMPRESSION_CONTEXTUAL_BANNER: "impression-contextual-banner",
    IMPRESSION_BOTTOM_HALF_CARD: "impression-bottom-half-card",
    // savings stamp
    IMPRESSION_SAVINGS_STAMP: "impression-mega-saved-green",

    // Gratification Popup
    IMPRESSION_ONE_GRATIFICATION_POPUP: "impression-one-gratification-popup",

    // One Membership Nudge
    IMPRESSION_ONE_CARTUPSELL_NUDGE: "impression-one-cartupsell-nudge",
    IMPRESSION_ONE_CARTUPSELL_PLAN_REMOVAL_HALFCARD: "impression-one-cartupsell-plan-removal-halfcard",
    IMPRESSION_ONE_CARTUPSELL_CHANGE_PLAN_CTA: "cart-upsell-change-plan-impression",

    // Delivery tab
    IMPRESSION_DELIVERY_TAB: "toggle-state-impression",

    // Remove coupon
    IMPRESSION_REMOVE_COUPON: "impression-remove-coupon",

    // Error half card
    IMPRESSION_HALF_CARD_INVALID_COUPON: "impression-half-card-invalid-coupon",

    // Savings Corner
    IMPRESSION_SAVINGS_CORNER_EXTRA_SAVINGS: "impression-savings-corner-extra-savings",

    // Savings Corner Habitforming
    IMPRESSION_SAVINGS_CORNER_HABIT_UNLOCK: "impression-savings-corner-habit-unlock",

    // One time promise
    IMPRESSION_ONE_BLACK_HALFCARD: "impression-one-blck-halfcard",
    IMPRESSION_OTP_CROUTON: "impression-otp-crouton",

    // Toast crouton
    IMPRESSION_TOAST_CROUTON: "impression-toast-message",
    //cutlery opt-in widget
    IMPRESSION_CUTLERY_OPT_IN_WIDGET: "impression-send-cutlery",

    // cart header lottie
    EXPRESS_CHECKOUT_ANIMATION_IMPRESSION: "express-checkout-animation-impression",
    OTG_CHECKOUT_ANIMATION_IMPRESSION: "OTG-checkout-animation-impression",
    BOLT_CHECKOUT_ANIMATION_IMPRESSION: "Bolt-checkout-animation-impression",
    HEADER_CHECKOUT_ANIMATION_IMPRESSION: "impression-checkout-header-animation",

    // delivery type offers
    IMPRESSION_DELIVERY_TYPE_OFFER: "impression-delivery-type-offer",
    IMPRESSION_DELIVERY_TYPE_OFFER_EXPIRED: "impression-delivery-type-offer-expired",

    // delivery eco-saver toast
    IMPRESSION_ECO_SAVER_TOAST_MESSAGE: "impression-toast-message",
    IMPRESSION_NO_RUSH_LOTTIE: "impression-norush-animation",

    //cart address nudge
    IMPRESSION_ADDRESS_DISTANCE_TOOLTIP: "impression-address-distance-tooltip",
    IMPRESSION_CHECKOUT_LAT_LNG: "impression-checkout-lat-lng",
    IMPRESSION_ADDRESS_CHANGE: "impression-address-change",

    // cart message personalised
    IMPRESSION_ADD_CAKE_MESSAGE_PILL: "impression-cake-special-instruction",
    IMPRESSION_HALF_CARD_CAKE_BUTTON: "impression-half-card-cake-button",
    // por ftue nudges
    IMPRESSION_DUAL_APPLICATION_CAPABILITY: "impression-dual-application-capability",
    IMPRESSION_MORE_OFFERS_STRIP: "impression-more-offers-strip",

    //special instructions half card
    IMPRESSION_HALF_CART_SPECIAL_INSTRUCTION: "impression-half-cart-special-instruction",

    //cancellation policy widget
    IMPRESSION_CC_POLICY_CART: "impression-cc-policy-cart",

    // Gifting Flow Impression Events
    IMPRESSION_OFFERS_COUPON_PAGE: "impression-offers-coupon-page",
    IMPRESSION_INDIVIDUAL_OFFERS_COUPON_PAGE: "impression-individual-offers-coupon-page",
    IMPRESSION_APPLY_SELECTED_COUPON_PAGE: "impression-apply-selected-coupon-page",
    IMPRESSION_SEARCH_BAR_COUPON_PAGE: "impression-search-bar-coupon-page",
    IMPRESSION_POP_UP: "impression-pop-up",
    //cartItems and cross-sell suggestions
    IMPRESSION_CART_WIDGET_RANKING: "impression-cart-widget-ranking",
    IMPRESSION_EMPTY_CART_REDIRECT: "impression-empty-cart-redirect",
    IMPRESSION_CAROUSEL_ITEM_DETAILS_POPUP: "impression-carousel-item-details-pop-up",
    IMPRESSION_CART_ITEM_DETAILS: "impression-cart-item-details",

    //stress comms
    IMPRESSION_CART_STRESS_COMM: "impression-cart-stress-comm",

    //Timed free cashback crouton
    IMPRESSION_CROUTON_TIMED_FREE_CASH: "impression-crouton-timed-free-cash",
    // Magic Items Error Crouton
    IMPRESSION_MAGIC_ITEMS_ERROR_CROUTON: "impression-magic-items-error-crouton",
    // Hotel In-Room Delivery Error Crouton
    IMPRESSION_HOTEL_DELIVERY_ERROR_TOAST: "impression-hotel-delivery-error-toast",
    // Toing Popup
    IMPRESSION_TOING_POPUP: "impression-toing-re-enforcement",

    // Bill Details Banner
    IMPRESSION_BILL_DETAILS_BANNER: "impression-bill-details-banner",
    IMPRESSION_BILL_DETAILS_BANNER_HALF_CARD: "impression-bill-details-banner-halfcard",
    // Subscription Renewal Nudge
    IMPRESSION_SUBSCRIPTION_RENEWAL_NUDGE_BLACK_PLAN: "impression-cartupsell-nudge-black",
    IMPRESSION_SUBSCRIPTION_RENEWAL_NUDGE_ONE_PLAN: "impression-cartupsell-nudge-one",
    IMPRESSION_SUBSCRIPTION_RENEWAL_REMOVAL_CTA_BLACK: "impression-cartupsell-removal-nudge-black",
    IMPRESSION_SUBSCRIPTION_RENEWAL_REMOVAL_CTA_ONE: "impression-cartupsell-removal-nudge-one",
    IMPRESSION_SUBSCRIPTION_RENEWAL_PLAN_REMOVAL_HALFCARD: "impression-subscription-renewal-plan-removal-halfcard",

    // Deal Rush Crouton
    IMPRESSION_CROUTON_DEAL_RUSH: "impression-offer-timer-crouton",
    IMPRESSION_CROUTON_DEAL_RUSH_EXPIRED: "impression-offer-expired-crouton",

    // Magic Items
    IMPRESSION_MAGIC_ITEMS_FTUE: "impression-magic-items-ftue",
    IMPRESSION_MAGIC_ITEMS_TIMER: "impression-magic-items-timer",
    IMPRESSION_MAGIC_ITEMS_EMPTY: "impression-magic-items-empty",
    IMPRESSION_MAGIC_ITEMS_UNLOCK_POPUP: "impression-magic-items-unlock-pop-up",
    IMPRESSION_MAGIC_ITEMS_OFFER_LIMIT: "impression-magic-items-offer-limit",

    // Splash Lottie
    IMPRESSION_CART_SPLASH_LOTTIE: "impression-cart-splash-lottie",

    //Ineligible OOS items
    IMPRESSION_REMOVE_ALL_OOS_ITEMS: "impression-remove-all-oos-items",

    //Toing Lpg
    IMPRESSION_TOP_CART_BANNER_D2C: "impression-top-cart-banner-d2c",
    IMPRESSION_NO_ADDRESS_D2C: "impression-no-address-d2c",
    IMPRESSION_TUTORIAL_D2C: "impression-tutorial-d2c",
    IMPRESSION_SCANNING_D2C: "impression-scanning-d2c",
    IMPRESSION_RESULT_D2C: "impression-result-d2c",
    IMPRESSION_TIMER_TOAST_D2C: "impression-timer-toast-d2c",
    IMPRESSION_FREE_CASH_WARNING_D2C: "impression-free-cash-warning-d2c",
    IMPRESSION_TIMER_TOAST_EXPIRY_D2C: "impression-timer-toast-expiry-d2c",

    // Toing Delivery Modes
    IMPRESSION_FTUE_NEW_TAG: "delivery-mode-new-tag",
    IMPRESSION_FTUE_CROUTON: "delivery-mode-ftue",
    IMPRESSION_CALLOUT: "delivery_mode_callout",

    // Cart load impression with prefetch context
    IMPRESSION_CART_LOAD: "impression-cart-load",

    // No Weekend Fee Popup
    IMPRESSION_NO_WEEKEND_FEE_POPUP: "impression-no-weekend-fee-pop-up",
};

export const PLACEHOLDERS = {
    OFFER_BUNDLE_SEMICOLON: "offer_bundle",
    OFFER_BUNDLE_HYPHEN: "offer-bundle",
    AUTO_ADD_SEMICOLON: "auto_add",
    AUTO_ADD_HYPHEN: "auto-add",
};

export const LABEL_NAME = {
    TURBO_WIDGET_TOOLTIP: "turbo-widget-tooltip",
    TURBO_WIDGET_TOOLTIP_CROSS: "turbo-widget-tooltip-cross",
};
